import { Button, Typography, useTheme } from "@mui/material";
import { Bin24Px, useToast } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";
import { getMessageFromRtkError } from "~/lib/rtkErrorToMessage";
import {
  selectSitePortIds,
  selectWorkstationAutostoreGridId
} from "~/redux/selectors/workstationsSelectors";
import { useSkipInductionBinMutation } from "~/redux/warehouse/autostoreGrid.hooks";

export function GetNewBinButton({ onSuccess }: { onSuccess: () => void }) {
  const { t } = useTranslation();
  const { errorToast } = useToast();
  const { palette } = useTheme();
  const trackedPageName = useMixpanelPageName();

  const autostoreGridId = useAppSelector(selectWorkstationAutostoreGridId);
  const allPortIds = useAppSelector(selectSitePortIds);

  const [skipInductionBin] = useSkipInductionBinMutation();

  const handleGetNewBin = async () => {
    if (!autostoreGridId || !allPortIds?.[0]) {
      return errorToast(t("missing required data"));
    }
    mixpanelTrack({
      trackedPageName,
      type: "Button Click",
      label: "Get New Bin",
      eventProperties: {
        PortId: allPortIds[0]
      }
    });
    try {
      await skipInductionBin({
        autostoreGridId,
        portId: allPortIds[0]
      }).unwrap();
      onSuccess();
    } catch (error) {
      errorToast(getMessageFromRtkError(error));
    }
  };

  return (
    <Button
      variant="subtle"
      size="large"
      startIcon={<Bin24Px fill={palette.primary.main} />}
      onClick={handleGetNewBin}
    >
      <Typography>{t("get new bin")}</Typography>
    </Button>
  );
}
